enum Language {
  EN = 'en',
  NL = 'nl',
}

/** Normalize persisted/legacy language values to a known Language enum member. */
export function normalizeLanguage(value: unknown): Language {
  const normalized = String(value ?? '')
    .toLowerCase()
    .split('-')[0];
  return normalized === Language.EN ? Language.EN : Language.NL;
}

export default Language;
